import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { GuideEmoticonListResponse, GuideEmoticonParams } from './type';

export const fetchGuideEmoticonList = async (params: GuideEmoticonParams) => {
  const res = await fetchExtended(`/v1/guide/emoticon`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as GuideEmoticonListResponse;
};
